import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { LoaderService } from './services/loader.service';
import { LoaderState } from './models/loader';


@Component({
    selector: 'max-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.css'],
    standalone: true,
    imports: [CommonModule, ProgressBarModule, ProgressSpinnerModule]
})
export class LoaderComponent implements OnInit {
  readonly show = signal(false);

  private readonly destroyRef = inject(DestroyRef);

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.loaderState
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state: LoaderState) => {
        this.show.set(state.show);
        // TODO: LoggingService trace loader state
      });
  }
}
